import { menuRoute, locationRoute } from "@/App";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/Hero";
import { MenuUpdateNotifications } from "@/components/MenuUpdateNotifications";
import { useLocationMenus } from "@/hooks/useLocationMenus";
import { useLocation } from "@/providers/LocationContextProvider";
import { Separator } from "@radix-ui/react-select";
import { Outlet, useRouter } from "@tanstack/react-router";
import { useMemo } from "react";

export function MenuLayout() {
  const { orderType } = useLocation();
  const { menuId } = menuRoute.useParams();
  const { locationId } = locationRoute.useParams();

  const { availableMenus } = useLocationMenus();

  const selectedMenu = useMemo(() => {
    return availableMenus.find((menu) => menu.id === menuId);
  }, [availableMenus, menuId]);

  const routeMatches = useRouter().state?.matches;

  const isReceipt = routeMatches.some(
    (route) => route.routeId === "/$locationId/$menuId/success/$paymentId"
  );

  return (
    <>
      <MenuUpdateNotifications 
        locationId={locationId} 
        menuId={menuId}
        enabled={!isReceipt} // Disable on receipt page
      />
      
      {isReceipt ? null : (
        <>
          <Hero
            showAddress={orderType === "TAKE_AWAY"}
            hours={selectedMenu?.visibleHours ?? []}
          />
          <Separator className="my-4" />{" "}
        </>
      )}

      <div id="menu-outlet">
        <Outlet key={selectedMenu?.id + "-" + orderType} />
      </div>

      {isReceipt ? null : (
        <>
          <Footer locationId={locationId} />
        </>
      )}
    </>
  );
}
